import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take, switchMap, filter } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Store, select } from '@ngrx/store';
import * as fromRoot from '../../app.reducer';

@Injectable()
export class UserClaimsGuard implements CanActivate {

    constructor(
        private _router: Router,
        private oidcSecurityService: OidcSecurityService,
        private store$: Store<fromRoot.State>,
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.oidcSecurityService.isAuthenticated$.pipe(
            take(1),
            switchMap(({ isAuthenticated }) => {
                if (!isAuthenticated) {
                    this._router.navigate(['login'], { queryParams: { returnUrl: state.url } });
                    return [false];
                }

                const requiredClaim = next.data && next.data['claim'];
                if (!requiredClaim) {
                    return [true];
                }

                return this.store$.pipe(
                    select(fromRoot.getUserInfo),
                    filter(profile => !!profile),
                    take(1),
                    map(profile => {
                        if (profile.claims && profile.claims.includes(requiredClaim)) {
                            return true;
                        }
                        this._router.navigate(['/settings']);
                        return false;
                    })
                );
            })
        );
    }
}
